import React from 'react';
import { Button } from './ui/button';

const Header = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-gray-900">Mitz Traders</h1>
            <span className="ml-2 text-sm text-gray-600">Trading & E-commerce Excellence</span>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium"
            >
              About Us
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('mitzcart')}
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium"
            >
              MitzCart
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium"
            >
              Contact
            </button>
          </nav>

          <Button 
            onClick={() => window.open('https://mitzcart.com', '_blank')}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 transition-colors duration-200"
          >
            Visit MitzCart
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;